import React, { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
  show: boolean;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, show }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  const getToastClass = () => {
    switch (type) {
      case 'success':
        return 'tw-bg-success tw-text-white';
      case 'error':
        return 'tw-bg-danger tw-text-white';
      case 'warning':
        return 'tw-bg-warning tw-text-black';
      case 'info':
        return 'tw-bg-info tw-text-black';
      default:
        return 'tw-bg-surface-alt tw-text-black';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return 'bi-check-circle';
      case 'error':
        return 'bi-x-circle';
      case 'warning':
        return 'bi-exclamation-triangle';
      case 'info':
        return 'bi-info-circle';
      default:
        return 'bi-bell';
    }
  };

  return (
    <div
      className="tw-fixed tw-top-0 tw-right-0 tw-p-3"
      style={{ zIndex: 9999 }}
    >
      <div
        className={`tw-rounded tw-shadow-sm ${getToastClass()}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="tw-flex tw-items-center">
          <div className="tw-p-3">
            <i className={`bi ${getIcon()} tw-mr-2`}></i>
            {message}
          </div>
          <button
            type="button"
            className="tw-text-white tw-mr-2 tw-m-auto"
            aria-label="Close"
            onClick={onClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast; 